<template>
  <div id="batch_boards">
    <!-- Create Batch Btn-->
    <vx-card class="mb-10">
      <div class="vx-row mb-5">
        <div class="vx-col pr-0">
          <vs-button v-if="checkPermissionByIds([permissions.BATCH_ADD])" @click="$router.push('/batches/create')" class="clear-filt-btn" color="primary" type="relief">Create Batch</vs-button>
        </div>
      </div>

      <!-- Select Box -->
      <div class="vx-row grid grid-cols-6 gap-5">
        <div class="vx-col pr-0">
          <vs-input name="text" icon="icon icon-search" class="rounded-lg search-bg w-full text-black" placeholder="Search Here....." icon-pack="feather" />
          <span class="text-danger text-sm block">{{ errors.first('step-1.Email') }}</span>
        </div>

        <!-- location filter -->
        <select-2
          class="w-full"
          ref="locationList"
          :value="filters.locationId"
          @input="(item) => (filters.locationId = item && item.value)"
          label-placeholder="Location"
          name="Location"
          placeholder="Select Location"
          newLabel="Add New Location"
          @addNew="
            () => {
              isAddLocationModalShow = true
            }
          "
          label="name"
          :ssr="true"
          :params="{ dropdownLocationId: filters.locationId }"
          action="location/fetchLocations"
          v-validate="'required'"
        />
        <!-- batch name -- filter -->
        <div class="batch_name__filter">
          <select-2
            class="w-full mb-1"
            :value="filters.id"
            @input="
              (item) => {
                filters.id = item && item.value
              }
            "
            @scrollEnd="getBatchList(batchFilters.page + 1)"
            name="Batch Name"
            placeholder="Batch Name"
            autocomplete
            :options="batchOptions"
          />
        </div>

        <div class="filter_rese ml-5 mb-1">
          <vs-button class="mr-2" color="danger" type="relief" @click="clearFilter">Clear Filter</vs-button>
        </div>
        <!-- product list options -->
        <div class="products__display_options col-span-2">
          <div class="btn-group flex justify-end">
            <vs-button color="success" @click="productView('list')">List View</vs-button>
            <vs-button color="danger" @click="productView('grid')">Grid View</vs-button>
          </div>
        </div>

        <!-- archieve or active btn -->
        <!-- This will show you all inactive batches, finished harvests and archived packages. -->
        <!-- <vx-tooltip fontSize="15" v-if="!this.isArchievedList" text="This will show you all inactive batches, finished harvests and archived packages.">
          <vs-button v-if="!this.isArchievedList" class="clear-filt-btn w-full text-xl font-bold" color="primary" type="relief" @click="$router.push({ name: 'batch-new-inactive-list' })">
            Archived
          </vs-button>
        </vx-tooltip> -->
        <!-- This will show you all active batches, unfinished harvests and active packages. -->
        <vx-tooltip fontSize="15" v-if="this.isArchievedList" text="This will show you all active batches, unfinished harvests and active packages.">
          <vs-button v-if="this.isArchievedList" class="clear-filt-btn w-full text-xl font-bold" color="primary" type="relief" @click="$router.push({ name: 'batch-new-list' })">Active</vs-button>
        </vx-tooltip>
      </div>
    </vx-card>

    <vue-perfect-scrollbar
      class="batch__board flex-grow py-5 vx-card flex flex-row"
      :settings="{
        wheelPropagation: true,
        minScrollbarLength: 0.6,
        wheelSpeed: 0.6
      }"
    >
      <batch-track
        v-for="(board, index) in boardConfig"
        :key="index"
        :trackTitle="board.boardName"
        :trackItems="handleRanderBatchItems(board)"
        :board="board"
        :isArchievedList="isArchievedList"
        :batchTrackfilter="filters"
      />
    </vue-perfect-scrollbar>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Select2 from '@/components/custom/form-elements/Select2.vue'
// import BatchStatusUpdateModal from './components/modals/batch/BatchStatusUpdateModal'
// import BatchChangeGrowthPhase from './components/modals/batch/BatchChangeGrowthPhase'
// import BatchDestroyPlants from './components/modals/batch/BatchDestroyPlants'
// import CreateBatchPackage from '@/views/batches/components/CreateBatchPackage.vue'
// import ReportWasteModal from '@/views/batches/components/ReportWasteModal.vue'
// import AssignPlantTag from '@/views/batches/components/modals/plants/AssignPlantTag.vue'
// import AddPlant from '@/views/batches/components/modals/plants/AddPlant.vue'
import AddLocationModal from '@/views/location/AddLocation'
import VxCard from '../../components/vx-card/VxCard.vue'
import BatchTrack from '@/views/batches/components/BatchTrack.vue'
import { batchBoardOptions } from '@/utils/batch-options.js'

export default {
  name: 'BatchList',

  components: {
    Select2,
    VuePerfectScrollbar,
    // BatchStatusUpdateModal,
    // BatchChangeGrowthPhase,
    // BatchDestroyPlants,
    // CreateBatchPackage,
    // ReportWasteModal,
    // AssignPlantTag,
    // AddPlant,
    AddLocationModal,
    VxCard,
    BatchTrack
  },

  props: {
    isArchievedList: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    processing: false,

    order: [],
    length: 15,
    page: 1,
    search: '',
    filters: {
      id: null,
      locationId: null,
      search: null
    },

    batch_boards: [],
    batchBoardOptions,

    // batch
    batchOptions: [],
    batchFilters: {
      page: 1,
      length: 10,
      order: [],
      search: null
    }
  }),

  mounted() {
    // get batch list
    this.getBatchList()
  },

  computed: {
    ...mapState('batch', ['batches', 'total', 'loading', 'FilteredCount']),
    ...mapState('permission', ['permissions']),
    ...mapGetters('auth', ['checkPermissionByIds']),

    boardConfig() {
      return batchBoardOptions
    },

    // clone, seeds, immature - board
    cloneOrSeedsBoard() {
      return this.batch_boards
        .filter((x) => x.counts.immaturePlantsCount > 0)
        .map((e) => {
          return {
            ...e,
            quantity: e.counts.immaturePlantsCount
          }
        })
    },

    // veg - board
    vegBoard() {
      return this.batch_boards
        .filter((x) => x.counts.vegetativePlantsCount > 0)
        .map((e) => {
          return {
            ...e,
            quantity: e.counts.vegetativePlantsCount
          }
        })
    },

    // flower - board
    flowerBoard() {
      return this.batch_boards
        .filter((x) => x.counts.floweringPlantsCount > 0)
        .map((e) => {
          return {
            ...e,
            quantity: e.counts.floweringPlantsCount
          }
        })
    },

    // harvest - board
    harvestBoard() {
      return this.batch_boards
        .filter((x) => x.counts.harvestedPlantsCount > 0)
        .map((e) => {
          return {
            ...e,
            quantity: e.counts.harvestedPlantsCount
          }
        })
    },

    // lab testing harvest - board
    labTestingHarvestBoard() {
      return this.batch_boards
        .filter((x) => x.counts.labTestingCount > 0)
        .map((e) => {
          return {
            ...e,
            quantity: e.counts.labTestingCount
          }
        })
    },

    // sellable items - board
    sellableItemsBoard() {
      return this.batch_boards
        .filter((x) => x.counts.sellableItemCount > 0)
        .map((e) => {
          return {
            ...e,
            quantity: e.counts.sellableItemCount
          }
        })
    }
  },

  methods: {
    ...mapMutations('batch', ['SET_STATE']),

    // get batch list
    async getBatchList(page = this.batchFilters.page) {
      this.batchFilters.page = page
      this.processing = true
      this.$store
        .dispatch('batch/getBatches', { page, limit: this.batchFilters.length, search: this.batchFilters.search, order: this.batchFilters.order })
        .then(({ data }) => {
          this.batchOptions.push(
            ...data.reduce((acc, item) => {
              item.label = `${item.batch_number} - ${item.batch_name}`
              acc.push(item)
              return acc
            }, [])
          )
          this.processing = false
        })
        .catch(({ message }) => {
          this.processing = false
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    // clear filter
    clearFilter() {
      this.filters.id = null
      this.filters.locationId = null
      this.filters.search = null
    },

    // render batch in batch tracks
    handleRanderBatchItems(data) {
      return this[data.boardItems]
    },

    // grid & list view in batch list
    productView(Rname) {
      this.$router.push({ name: Rname === 'list' ? 'batch-list' : 'batch-new-list' })
    }
  },

  watch: {
    processing() {
      if (this.processing) {
        this.$vs.loading({
          container: '#batch_boards',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#batch_boards > .con-vs-loading')
      }
    },
    filters: {
      deep: true,
      handler() {
        this.getBatchList()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#batch_boards {
  .vx-card {
    max-height: calc(100vh - 18rem);
  }
  .search-bg {
    background-color: #28c76f;
    color: #006622;
  }

  .growth_list {
    max-height: calc(100vh - 21rem);
    padding: 10px 5px;
    border-radius: 10px;
    overflow: hidden;

    .batch_options {
      margin-top: 15px;
    }

    .batch {
      width: 100%;
      padding: 10px;

      &.batch-bg {
        background-color: #f6f8fe;
        border-radius: 10px;
        transition: all 0.5s;
        border: 2px solid transparent;
        &:hover {
          background-color: transparent;
          border: 2px solid #28c76f;
        }
      }

      &:first-child {
        margin-top: 0;
      }
    }
    &.batch-list-hover {
      min-width: calc(25% - 1rem);
      max-width: calc(25% - 1rem);
      border: 2px solid transparent;
      &:hover {
        border: 2px solid #28c76f;
      }
    }
    .settings-icon {
      color: #28c76f;
    }
  }
}

#batchtrack {
  min-width: calc(25% - 1rem);
  max-width: calc(25% - 1rem);
}

.invoice__actions {
  width: 250px;
  li {
    padding: 5px;
    a {
      display: flex !important;
      font-weight: bold;
      align-items: center;
    }
  }
}
</style>

<style lang="scss">
.batch__board {
  position: relative;

  .con-vs-loading {
    position: absolute;
  }
}

.vs-dropdown--item:hover .vs-dropdown--item-link {
  font-weight: 700;
}
#batch_tracks .batch_list .batch_options {
  margin-top: 0;
}

#batch_tracks .batch_list .batch_options {
  margin-top: 0 !important;
}
#batch_tracks .drop-border {
  border: 1px solid rgba(0, 0, 0, 0.3) !important;
  padding: 10px;
}
.ps > .ps__scrollbar-y-rail {
  width: 5px;
}
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
  width: 5px;
}
</style>
